import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';

const scrollHint = () => {
    new ScrollHint('.js-scrollable', {
        i18n: {
            scrollable: 'スクロールできます'
        }
    });
};

export default scrollHint;